import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function AdminTopbarPortal({ children }) {
  const [host, setHost] = useState(null);
  const [desktop, setDesktop] = useState(() => window.matchMedia('(min-width: 901px)').matches);

  useLayoutEffect(() => {
    setHost(document.getElementById('admin-page-actions'));
    const media = window.matchMedia('(min-width: 901px)');
    const handleChange = event => setDesktop(event.matches);
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, []);

  if (!desktop) return children;
  return host ? createPortal(children, host) : null;
}
